<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">About Us</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                                    <li class="breadcrumb-item active" aria-current="page">About Us</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="about-us-area-2 mb-60">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-5">
                        <div class="about-us-thumb">
                            <img src="/images/about-us-thumb.jpg" alt="about">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-7">
                        <div class="about-us-content">
                            <span>We provide</span>
                            <h4 class="title">Fresh Fruits</h4>
                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque quae ab illo inventore veritatis et quasi.</p>
                            <p>Architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, totam rem aperiam.</p>
                            <a href="blog-details.html">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="sub-sbout-area pb-85">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-6">
                        <div class="sub-about-item text-center mt-30">
                            <i class="pe-7s-car"></i>
                            <h6 class="title">Free Shipping from $100</h6>
                            <p>Free shipping on purchases over.</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="sub-about-item text-center mt-30">
                            <i class="pe-7s-cash"></i>
                            <h6 class="title">Money back guaranteed</h6>
                            <p>Lorem ipsum dolor sit amet conset</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="sub-about-item text-center mt-30">
                            <i class="pe-7s-lock"></i>
                            <h6 class="title">Secure Payment</h6>
                            <p>Lorem ipsum dolor sit amet consec</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="sub-about-item text-center mt-30">
                            <i class="pe-7s-check"></i>
                            <h6 class="title">100% authenticity guaranteed</h6>
                            <p>Lorem ipsum dolor sit amet adiscing</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "AboutUs"
    }
</script>

<style scoped>

</style>